export const enum AppEntityType {
  PROVIDER_NOTE = 8,
  INVOICE_ATTACHMENT = 18,
  INVOICE_NOTE = 22,
  POTENTIAL_INVOICE_ATTACHMENT = 25,
  MERGED_INVOICE_ATTACHMENT = 28,
  MERGED_INVOICE_NOTE = 29,
  FACILITY_CREDENTIAL = 30,
  FILLED_PROVIDER_FACILITY_CREDENTIAL = 31
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/AppEntityType.ts